export var EWebsiteContentType;
(function (EWebsiteContentType) {
    EWebsiteContentType["WEBSITE"] = "WEBSITE";
    EWebsiteContentType["IMAGE"] = "IMAGE";
    EWebsiteContentType["ICON"] = "ICON";
    EWebsiteContentType["VIDEO"] = "VIDEO";
    EWebsiteContentType["ARTICLE"] = "ARTICLE";
    EWebsiteContentType["NEWS_ARTICLE"] = "NEWS_ARTICLE";
    EWebsiteContentType["FILE"] = "FILE";
})(EWebsiteContentType || (EWebsiteContentType = {}));
